import { CreditCardFinancialEntity } from '../../financialEntities';
import { AmountRecurrence } from '../../types';
import { YM } from '../../yearMonth';
import { makeValueSeriesGenerator } from '../makeGenerator';
import { FEValueNode, SnapshotBase, VSGContext } from '../types';
import {
    defaultLoanEntityParams,
    loanSeriesFromDefaultLoanParams,
    makeDefaultCurrentValueNodeGenerator,
    makeDefaultPastValueNodeGenerator,
} from './helpers';

type Params = {
    balance?: number;
    interestRate?: number;
    payment?: number;
    currentPayment?: number;
    plannedPayment?: AmountRecurrence;
    isPaidOffMonthly?: 'true' | 'false';
};

export const makeCreditCardValueSeriesGenerator = (
    entity: CreditCardFinancialEntity,
    snapshots: SnapshotBase[],
    ctx: VSGContext,
    params: Params = {}
) => {
    const loanParams = defaultLoanEntityParams(entity, params);
    const loanSeries = loanSeriesFromDefaultLoanParams(
        loanParams,
        ctx.currentDate
    );
    const isPaidOffMonthly =
        params.isPaidOffMonthly === 'true'
            ? true
            : params.isPaidOffMonthly === 'false'
              ? false
              : entity.info.isPaidOffMonthly;
    const vnParams = { ...ctx.baseValueNodeParams };

    return makeValueSeriesGenerator<SnapshotBase, FEValueNode>({
        snapshots,
        currentDate: ctx.currentDate,
        generatePastValueNode: makeDefaultPastValueNodeGenerator<SnapshotBase>({
            ...vnParams,
        }),
        generateCurrentValueNode:
            makeDefaultCurrentValueNodeGenerator<SnapshotBase>({
                currentValue: loanParams.currentValue,
                ...vnParams,
            }),
        generateFutureValueNode: ({ tick }) => {
            const balance = isPaidOffMonthly
                ? 0
                : loanSeries.balanceOn(YM.make(tick.date));
            return { ...tick, ...vnParams, balance };
        },
    });
};
